import { render, staticRenderFns } from "./getsalsumascustomer.vue?vue&type=template&id=0e0452e5&scoped=true&"
import script from "./getsalsumascustomer.vue?vue&type=script&lang=js&"
export * from "./getsalsumascustomer.vue?vue&type=script&lang=js&"
import style0 from "./getsalsumascustomer.vue?vue&type=style&index=0&id=0e0452e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0452e5",
  null
  
)

export default component.exports